const items = {
  "flashes.success": "操作成功",
  "message.irrevocable": "此操作不可撤销",
  "message.delete.confirm": "确定删除吗？",
  "message.auth.guest.alert":
    "服务器未返回登录信息，目前只能查看公开数据，其他功能无法使用；请刷新页面或重新登录。",
  "message.channel.empty.alert": "没有版本风格被选择,仅显示原文。",
  "message.time": "用时 {time} 秒",
  "message.result": "{count} 条结果",
  "message.send.reset.email":
    "系统将向您的注册邮箱发送邮件。请输入您的注册邮箱。并确保该邮箱可以接受邮件。",
  "message.send.reset.email.successful": "重置密码的邮件已经发送到您的邮箱",
  "message.password.reset.successful": "重置密码成功",
  "message.password.reset": "请设置新的密码",
  "message.get.token.fail": "获取token失败",
  "message.confirm-password.validate.fail": "两次密码不一致",
  "message.delete.success": "成功删除{count}条数据",
  "message.task.status.change": "将任务状态修改为{status}吗？",
};

export default items;
